<p-card>
  <ng-template #title>Define Study Information </ng-template>
  <ng-template #subtitle>
    Enter details about your study
  </ng-template>

  <div class="field flex flex-row align-items-start py-2">
    <label for="studyId" class="w-full md:w-2 mb-2 md:mb-0 flex-shrink-0">Provisional Study ID</label>
    <div class="w-full md:flex-1">
      <input
        #name="ngModel"
        id="studyId"
        type="text"
        class="w-full"
        required
        pInputText
        [(ngModel)]="studyId"
        [disabled]="true"
        />
    </div>
  </div>
  <div class="field flex flex-row align-items-start py-2">
    <label for="name" class="w-full md:w-2 mb-2 md:mb-0 flex-shrink-0">Title</label>
    <div class="w-full md:flex-1">
      <input
        #name="ngModel"
        id="name"
        type="text"
        minlength="10"
        class="w-full"
        required
        pInputText
        [(ngModel)]="studyName"
        [ngClass]="{
          'ng-dirty':
            (name.invalid && submitted) || (name.dirty && name.invalid)
        }"
        />
      @if ((name.invalid && submitted) || (name.dirty && name.invalid)) {
        <small class="p-error w-full">Please enter a name (at least
          {{ nameMinLength }} characters).</small>
        }
      </div>
    </div>
    <div class="field flex flex-row align-items-start py-2">
      <label for="description" class="w-full md:w-2 mb-2 md:mb-0 flex-shrink-0">Summary</label>
      <div class="w-full md:flex-1">
        <textarea
          #description="ngModel"
          id="description"
          type="text"
          minlength="20"
          class="w-full"
          required
          pInputTextarea
          [(ngModel)]="studyDescription"
        [ngClass]="{
          'ng-dirty':
            (description.invalid && submitted) ||
            (description.dirty && description.invalid)
        }"
          [rows]="5"
        ></textarea>
        @if (
          (description.invalid && submitted) ||
          (description.dirty && description.invalid)
          ) {
          <small class="p-error w-full">Please enter a description (at least
            {{ descriptionMinLength }} characters).</small>
          }
        </div>
      </div>

      <div class="field flex flex-row align-items-start py-2">
        <label for="doi" class="w-full md:w-2 mb-2 md:mb-0 flex-shrink-0">DOI</label>
        <div class="w-full md:flex-1">
          <input
            #doi="ngModel"
            id="doi"
            type="text"
            class="w-full"
            required
            pInputText
            [(ngModel)]="studyPublicationDoi"
        [ngClass]="{
          'ng-dirty':
            (doi.invalid && submitted) || (doi.dirty && doi.invalid)
        }"
            />
          @if ((doi.invalid && submitted) || (doi.dirty && doi.invalid)) {
            <small class="p-error w-full">Please enter a valid doi or leave field empty!</small>
            }
          </div>
        </div>

        <div class="field flex flex-row align-items-start py-2">
          <label for="dataLicenses" class="w-full md:w-2 mb-2 md:mb-0 flex-shrink-0">Data License</label>
          <div class="w-full md:flex-1">
            <p-select [options]="dataLicenses" [(ngModel)]="dataLicense" id="dataLicenses" [checkmark]="true"
              placeholder="Please select a data license for the file!" class="w-full">
              <ng-template let-dataLicense pTemplate="item">
                <div class="flex items-center gap-2">
                  <div>{{ dataLicense.licenseName }}&nbsp;({{ 'LICENSES.'+dataLicense.licenseId | uppercase | translate
                  }})</div>
                </div>
              </ng-template>
              <ng-template pTemplate="selectedItem">
                @if (dataLicense) {
                  <div class="flex items-center gap-2">
                    <div>{{ dataLicense.licenseName }}&nbsp;({{ 'LICENSES.'+dataLicense.licenseId | uppercase | translate
                    }})</div>
                  </div>
                }
              </ng-template>
            </p-select>
          </div>
        </div>
      <ng-template #footer>
        <div class="flex justify-content-between flex-wrap flex-row">
          <p-buttongroup>
            <button
              pButton
              type="button"
              label="Back"
              (click)="previousPage($event)"
              icon="fa fa-chevron-left"
              iconPos="left"
            ></button>
            <button
              pButton
              type="button"
              label="Cancel"
              (click)="cancel($event)"
              icon="fa fa-times"
              iconPos="right"
              class="p-button-danger"
            ></button>
          </p-buttongroup>
          <button
            pButton
            type="button"
            label="Next"
            (click)="nextPage($event)"
            icon="fa fa-chevron-right"
            iconPos="right"
          ></button>
        </div>
      </ng-template>
    </p-card>
